module.exports = __webpack_public_path__ + "static/media/mewa.1bb35864.png";